import * as Phaser from 'phaser';

const WIDTH = 100;
export const TIMER_BAR_HEIGHT = 20;
const RADIUS = 10;
const BORDER_THICKNESS = 2;
const DEFAULT_BACKGROUND = 0;
const DEFAULT_FOREGROUND = 0xffffff;
const HALF_WIDTH = WIDTH / 2;
const HALF_HEIGHT = TIMER_BAR_HEIGHT / 2;

const X_START = -HALF_WIDTH;
const Y_START = -HALF_HEIGHT;
const FILLED_INITIAL_WIDTH = (WIDTH - (BORDER_THICKNESS * 2));
const FILLED_HEIGHT = TIMER_BAR_HEIGHT - (BORDER_THICKNESS * 2);
const FILLED_X_START = X_START + BORDER_THICKNESS;
const FILLED_Y_START = Y_START + BORDER_THICKNESS;
const FILLED_RADIUS = RADIUS - 2;

/*
I'm stealing this code from this example: https://labs.phaser.io/edit.html?src=src\game%20objects\graphics\health%20bars%20demo.js
The example isn't documented well, but it sets up a health bar that has 3 parts: an outline, a v and the actual health part
We're just using the outline and actual health part since we can just use the outline as the background
*/

class TimerBar extends Phaser.GameObjects.Container {
	private bar: Phaser.GameObjects.Graphics;
	private initialValue = 0;
	private currentValue: number = 0;
	private tween: Phaser.Tweens.Tween = null;

	constructor(
		scene: Phaser.Scene,
		x?: number,
		y?: number,
		children?: Phaser.GameObjects.GameObject[],
		public backgroundColor = DEFAULT_BACKGROUND,
		public foregroundColor = DEFAULT_FOREGROUND,
	) {
		super(scene, x, y, children);
		this.bar = new Phaser.GameObjects.Graphics(scene);
		this.add(this.bar);
	}

	set value(newValue: number | undefined) {
		if (newValue === this.initialValue) {
			return;
		}

		this.initialValue = newValue;

		this.setupTween();
	}

	private setupTween() {
		this.bar.clear();
		this.tween?.destroy?.();

		if (!this.initialValue) {
			return;
		}

		this.currentValue = this.initialValue;

		this.tween = this.scene.tweens.add({
			targets: this,
			duration: this.initialValue * 1000,
			currentValue: 1,
			onComplete: () => {
				this.initialValue = undefined;
				this.bar.clear();
			},
			onUpdate: () => {
				this.drawBars(this.currentValue / this.initialValue);
			},
		});
	}

	private drawBars(progress: number) {
		this.bar.clear();

		this.bar.fillStyle(this.backgroundColor);
		this.bar.fillRoundedRect(X_START, Y_START, WIDTH, TIMER_BAR_HEIGHT, RADIUS);
		// this.bar.fillRect(X_START, Y_START, WIDTH, TIMER_BAR_HEIGHT);

		const innerWidth = Math.max(FILLED_RADIUS * 2, FILLED_INITIAL_WIDTH * progress); //if the width is smaller than the radius, it gets weird
		this.bar.fillStyle(this.foregroundColor);
		this.bar.fillRoundedRect(FILLED_X_START, FILLED_Y_START, innerWidth, FILLED_HEIGHT, FILLED_RADIUS);
		// this.bar.fillRect(FILLED_X_START, FILLED_Y_START, innerWidth, FILLED_HEIGHT);
	}
}

export default TimerBar;
